export enum ServiceFlag {
  AXS = "axs",
  Clearcorrect = "clearcorrect",
  EShop = "eshop",
  Registry = "registry",
  SIAB = "siab",
  Sales = "sales",
  Vivo = "vivo",
}
